import React from 'react'
import { SEO } from '../../../components/Seo/seo'
import { editCompanyProfile } from '../../../utils/pages-meta.json'
import EinvoiceDelegatesContent from '../../../components/Workspace/EinvoiceDelegates'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { useIntl } from 'react-intl'
import InActiveUserContent from '../../../components/InActiveUserContent'
import { SearchLoader } from '../../../components/Loader/SearchLoader'

const EinvoiceDelegates = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'PageTitle.EinvoiceDelegates' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax-Workspace' })}
           image={editCompanyProfile.image}
           description={intl.formatMessage({ id: 'PageTitle.EinvoiceDelegates' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, isUserActive, userData, resetSelectedCompany }) => (
          <>
            {!!userDataLoading && <SearchLoader loading={true}/>}
            {(!!Object.keys(userData).length && !!isUserActive) ?
              <EinvoiceDelegatesContent resetSelectedCompany={resetSelectedCompany}/>
              : (!userDataLoading && <InActiveUserContent/>)
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default EinvoiceDelegates
